import React, {useCallback, useState} from 'react';
import { useFormikContext } from 'formik';
import styles from './Field.module.css';
import {ReactComponent as AjouterIcone} from '../../icons/ajouter.svg';
import {ReactComponent as SupprimerIcone} from '../../icons/supprimer.svg';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');


const jours = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const FieldDateFrequency = ({ name }) => {
    const { setFieldValue } = useFormikContext();
    const [creneaux, setCreneaux] = useState({});
    const [selectedTime, setSelectedTime] = useState(moment("12:00", "HH:mm"));

    const ajouterCreneau = useCallback((jour) => {
        const heure = selectedTime.hour();
        const minutes = selectedTime.minute();
        const nouveauCreneau = heure * 60 + minutes;
        const creneauxDuJour = creneaux[jour] || [];

        if (creneauxDuJour.includes(nouveauCreneau)) return console.error('Créneau déjà existant');

        const nouveauxCreneaux = {
            ...creneaux,
            [jour]: [...creneauxDuJour, nouveauCreneau].sort((a, b) => a - b),
        };

        setCreneaux(nouveauxCreneaux);
        setFieldValue(name, nouveauxCreneaux);
    }, [creneaux, selectedTime, setFieldValue, name]);

    const supprimerCreneau = useCallback((jour, creneau) => {
        const nouveauxCreneaux = {
            ...creneaux,
            [jour]: creneaux[jour].filter(c => c !== creneau),
        };
        setCreneaux(nouveauxCreneaux);
        setFieldValue(name, nouveauxCreneaux);
    }, [creneaux, setFieldValue, name]);

    const formatMinutes = (totalMinutes) => {
        const h = Math.floor(totalMinutes / 60);
        const m = String(totalMinutes % 60).padStart(2, '0');
        return `${h}h${m}`;
    };

    return (
        <div className={styles.fieldDateFrequencyContainer}>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="fr">
                <TimePicker
                    value={selectedTime}
                    onChange={setSelectedTime}
                    slotProps={{ textField: { variant: 'outlined' } }}
                    ampm={false}
                    format="HH:mm"
                    views={['hours', 'minutes']}
                />
            </LocalizationProvider>

            <div className={styles.fieldDateFrequencyDaysContainer}>
                {jours.map((jour, index) => (
                    <div key={jour} className={styles.fieldDateFrequencyCol}>
                        <button type="button" onClick={() => ajouterCreneau(index + 1)}>
                            <AjouterIcone /> {jour}
                        </button>

                        {creneaux[index + 1] && (
                            <div>
                                {creneaux[index + 1].map((creneau) => (
                                    <div key={creneau} style={{
                                        marginBottom: "6px"
                                    }}>
                                        <button className={"btn"}
                                                type="button"
                                                onClick={() => supprimerCreneau(index + 1, creneau)}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    flexDirection: "row",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f3e4e4",
                                                }}
                                        >
                                            {formatMinutes(creneau)}

                                            <SupprimerIcone />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};


export default FieldDateFrequency;